import React, { useEffect, useState } from "react";
import { ApiService } from "../../../service/api.service";
import { OPERTIONS_URL } from "../../../common/common";
import InfiniteScrollContainer from "../../../components/InfiniteScroll/InfiniteScroll";
import moment from "moment";
import CustomChip from "../../../components/Chip";
import CustomCard from "../../../components/Card";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../components/AddButton";
import { Plus } from "../../../common/svg";

const BookingDraft = () => {
  const navigate = useNavigate();
  const apiService = new ApiService();
  const entityId = localStorage.getItem("entity_id");
  const [draftData, setDraftData] = React.useState<any>([]);
  const [hasMore, setHasMore] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const [page, setPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [activeCardIndex, setActiveCardIndex] = useState<number | null>(null);
  const [bookingID, setBookingID] = useState<string>("");
  const [viewBookingDetails, setViewBookingDetails] = useState<boolean>(false);

    const handleViewBookingDetails = (index: number,item:any) => {
    setActiveCardIndex(index);
    setBookingID(item.bookingId);
    setViewBookingDetails(true);
  };

  const fetchMoreData = async () => {
    if (!hasMore || isFetching) return;

    setIsFetching(true);

    try {
      const response: any = await apiService.getApi(
        `${OPERTIONS_URL}/draft-booking/get-all-route`
      );

      if (response?.status === "200") {
        const newBookings = response.body.data || [];
        const pagination = response.body.pagination;

        setDraftData((prev: any) => [...prev, ...newBookings]);

        // Update pagination details
        setHasMore(pagination.hasNextPage);
        setTotalRecords(pagination.totalRecords);

        if (pagination.hasNextPage) {
          setPage((prev) => prev + 1);
        }
      }
    } catch (error) {
      console.error("Error fetching bookings:", error);
      setHasMore(false);
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    fetchMoreData();
  }, [entityId]);

  return (
    <div className="bg-white rounded-[20px] pt-2">
      <div className="flex justify-between border-b border-[#C1C1C1] border-dashed p-2">
        <p className="text-[#444FBD] text-[16px]  font-[600]">
          {`Booking Draft Details`}
        </p>
        <CustomButton icon={Plus} label="" onClick={()=>navigate("/booking/newbooking")} />
      </div>
      <div className="flex flex-row gap-2 mt-4 ">
        <InfiniteScrollContainer
          width="400px"
          fetchMoreData={fetchMoreData}
          hasMore={hasMore}
          isFetching={isFetching}
        >
          <div>
            {draftData?.map((booking: any, index: number) => (
              <CustomCard
                key={index}
                onClick={() => handleViewBookingDetails(index, booking)}
                isActive={activeCardIndex === index}
                className="w-[350px] shadow-[1px_-1px_3.6px_2px_#00000033] p-2 rounded"
              >
                <div className="gap-[-1]">
                  <div className="flex justify-between items-center ">
                    <div className="flex items-center gap-2 w-fit">
                      <div className="flex-1 min-w-0">
                        <p
                          className="font-semibold truncate"
                          title={booking.bookingName}
                        >
                          {booking.bookingName}
                        </p>
                      </div>
                      <CustomChip
                        text={
                          booking.bookingStatus
                            ? booking.bookingStatus
                            : "Not Assigned"
                        }
                        textColor="#FF973C"
                        borderColor="#FF973C"
                        className="flex-shrink-0"
                      />
                    </div>

                    <p className=" font-[400] text-[14px]">#0{index + 1}</p>
                  </div>
                  <div className=" flex justify-between">
                    <div className="leading-[18px]">
                      <p className="text-[14px]">#{booking.bookingNumber}</p>
                      <p className="text-[14px]">
                        {moment(booking.startDate).format(
                          "DD MMMM YYYY, hh:mma"
                        )}
                      </p>
                    </div>
                    <div className="flex items-center flex-col  justify-center">
                      {/* <DaysLeftCounter
                        totalDays={booking.totalTrips ? booking.totalTrips : 0}
                      /> */}
                      {/* <p className="text-[14px] font-[400]">Total Trip</p> */}
                    </div>
                  </div>
                  <div className="flex justify-between items-end">
                    <div className="flex flex-col leading-[15px]">
                      <p className="text-[14px]">Client</p>
                      <button
                        className={`font-medium text-[14px]  ${
                          activeCardIndex === index
                            ? "text-[#F7941D]"
                            : "text-[#444FBD]"
                        }`}
                        // onClick={() =>
                        //   navigate(`/client/view/${booking?.clientDetail?.clientId}`)
                        // }
                      >
                        {booking.clientFirstName
                          ? booking.clientFirstName
                          : "Client Name"}
                      </button>
                    </div>
                    <p className="text-[14px] font-[600]">
                      {booking.tripType ? "" : "no type"}
                    </p>
                  </div>
                </div>
              </CustomCard>
            ))}
          </div>

        </InfiniteScrollContainer>
          <div className="flex justify-center items-center w-full h-[200px]">
            {viewBookingDetails && (
              <div className="">
                <button className="bg-[#444FBD] text-white rounded-[10px] px-4 py-2 font-[500] text-[16px]" onClick={()=>navigate(`draft/${bookingID}`)}>
                  Update Draft
                </button>
              </div>
            )}
          </div>
      </div>
    </div>
  );
};

export default BookingDraft;
